import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import {
  CmpTypographyField,
  CmpTextField,
  CmpSelectBox,
  CmpDatePicker,
  CmpDatePicker001,
  CmpDatePickerField,
  CmpSelectField,
  CmpInputField,
  CmpTextFieldEnter,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";

export default function WmsHead({
  xref,
  vRdxHead,
  xErrorMsg,
  vRdxuserLoc,
  fLocation,
  fDate,
  sDetail_Grid_Row,
  xGC_Toggle_Head_BinName_onKeyUp,
  xfGC_Toggle_Head_BinName_Name,
  sEnterKeyObj,
  vMediaQuery

}) {
  return (
    <form id="WmsStockAdjustmentHead">
      <Grid
        container
        rowSpacing={{ xs: 0.5, sm: 0.5, md: 0.5 }}
        columnSpacing={{ xs: 0.5, sm: 0.5, md: 0.5 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        className="align-items-center"
      >
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Sheet No"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpInputField
            xValue={vRdxHead.SheetNo}
            xType={"text"} // text/number/password
            xName={"SheetNo"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsg.SheetNo === "" ? false : true}
            xErrorMessage={xErrorMsg.SheetNo}
          />
        </Grid>



        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Date"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpDatePickerField
            xtabIndex={"6"}
            xValue={vRdxHead.Date}
            xOnChange={fDate}
            xName={"Date"}
            xError={xErrorMsg.Date === "" ? false : true}
            xErrorMessage={xErrorMsg.Date}
          // xOnKeyUp={(e) => {
          //   xFocusInput("A_RefDocNo");
          // }}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Bin Code"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpInputField
            xValue={vRdxHead.BinCd}
            xType={"text"} // text/number/password
            xName={"BinCd"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}

          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Bin Name"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <GCToggleSearch
            xName={"BinName"}
            xType={"text"}
            xValue={vRdxHead.BinName}
            xReadOnly={sDetail_Grid_Row.length > 0 ? true : false}
            xOnChange={xfGC_Toggle_Head_BinName_Name} //GCToggleSearch onchange main input
            xOnKeyUp={xGC_Toggle_Head_BinName_onKeyUp} //GCToggleSearch xOnKeyUp main input
            xError={false}
            xErrorMessage={""}
            xMediaQuery={false}
            xonClickbtn={xGC_Toggle_Head_BinName_onKeyUp} // GCToggleSearch onclick icon open div on main screen

          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Location"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpSelectField
            xtabIndex={"5"}
            xLabelText="Loc"
            xValue={vRdxHead.Loc}
            xOnChange={fLocation}
            xName={"Loc"}
            xData={vRdxuserLoc}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsg.LocName === "" ? false : true}
            xErrorMessage={xErrorMsg.LocName}
            xDisable={sDetail_Grid_Row.length > 0 ? true : false}
          />
        </Grid>
      </Grid>
    </form>
  );
}
